"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const LocalPhone_1 = __importDefault(require("@mui/icons-material/LocalPhone"));
const ContactPage_1 = __importDefault(require("../../Pages/Redesign/ContactPage"));
const ContactModalWrapper = styled_components_1.default.div `
  padding: 16px;

  .modal-title span {
    font-size: 20px;
  }
`;
const listItemStyle = {
    div: {
        cursor: 'pointer',
        paddingLeft: '0px',
    },
    icon: {
        marginRight: '15px',
    },
};
const ContactModal = ({ onClose }) => (react_1.default.createElement(ContactModalWrapper, null,
    react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: "collapse-btn", onClick: () => {
            onClose();
        }, sx: {
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: '2',
            backgroundColor: '#fff',
            opacity: '0.75',
        } },
        react_1.default.createElement(Close_1.default, null)),
    react_1.default.createElement(material_1.ListItem, { style: listItemStyle.div },
        react_1.default.createElement(LocalPhone_1.default, { htmlColor: "black", style: listItemStyle.icon }),
        react_1.default.createElement(material_1.ListItemText, { primary: i18n_js_1.default.t('contact'), className: "modal-title" })),
    react_1.default.createElement(ContactPage_1.default, { isLoadedFromSettingPage: true })));
exports.default = ContactModal;
